import { createGlobalStyle } from 'styled-components'
import { keyframes } from 'theme/state'
import chatIcon from 'images/chat.svg'

const GlobalStyle = createGlobalStyle`

  ${keyframes}

  :root {
    --sidenav_width: 0;
    --header_height: 55px;
    --window-body-offset-top: var(--header_height);
    --window-body-offset-left: 0px;
    --window-body-height: calc(100vh - var(--header_height));
  }

  ${props =>
    props.theme.internalMixins.mq(
      `
    :root {
      --window-body-offset-top: 0px;
      --window-body-offset-left: var(--sidenav_width);
      --window-body-height: 100vh;
    }
  `,
      'md'
    )}

  *, *::before, *::after {
    box-sizing: border-box;
    margin: 0;
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    font-family: inherit;
    color: inherit;
    -webkit-tap-highlight-color: transparent;
    text-decoration: none;
  }

  ::placeholder {
    color: ${props => props.theme.palette.text.neutralCool_700};
  }

  ::selection {
    background: ${({ theme }) => theme.palette.neutral[500]};
  }

  ::-webkit-calendar-picker-indicator {
    // display: none;
    opacity: 0;
    padding-right: 7px;
    font-size: 16px;
    line-height: 16px;
    // -webkit-appearance: none;
  }

  input[type=number]::-webkit-outer-spin-button,
  input[type=number]::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
  }

  input[type=number] {
      -moz-appearance:textfield;
  }

  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  textarea:-webkit-autofill,
  textarea:-webkit-autofill:hover,
  textarea:-webkit-autofill:focus,
  select:-webkit-autofill,
  select:-webkit-autofill:hover,
  select:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px ${props =>
      props.theme.palette.background.paper.main} inset;
  }

  html {
    overflow-y: initial !important;
  }

  body {
    height: 100%;
    width: 100%;
    max-width: 100vw;
    overflow-x: hidden;
    overflow-y: overlay;
    box-sizing: border-box;
    color: ${({ theme }) => theme.palette.text.main};
  }

  // body::-webkit-scrollbar {
  //   display: none;
  // }

  // body {
  //   -ms-overflow-style: none;
  //   scrollbar-width: none;
  // }

  body {
    font-family: degular, degular-text, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  body.fontLoaded {
    font-family: degular, degular-text, 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  .donde_app-wrapper {
    height: 100vh;
    overflow: hidden;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    background-color: ${props => props.theme.palette.background.main.main};
    color: ${props => props.theme.palette.background.main.text};

    ${props =>
      props.theme.internalMixins.mq(
        `
      flex-direction: ${props.hideSidenav ? 'column' : 'row'};
    `,
        'md'
      )}
  }

  .donde_body-wrapper {
    overflow-y: auto;
    display: grid;
    width: 100%;
    grid-template-rows: auto 1fr auto;
    height: 100%;
    background-color: ${props => props.theme.palette.background.default.main};
    color: ${props => props.theme.palette.background.default.text};
    min-height: 100vh;
    flex-grow: 1;
  }

  .donde_body-content {
    display: grid;
    grid-template-rows: 1fr;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    flex-grow: 1;
  }

  a {
    // text-decoration: none !important;
  }

  .cross-fade-leave {
    opacity: 1;
  }
  .cross-fade-leave.cross-fade-leave-active {
    opacity: 0;
    transition: opacity .5s ease-in;
  }

  .cross-fade-enter {
    opacity: 0;
  }
  .cross-fade-enter.cross-fade-enter-active {
    opacity: 1;
    transition: opacity .5s ease-in;
  }

  .cross-fade-height {
    transition: height .5s ease-in-out;
  }

  .fade-wait-leave {
    opacity: 1;
  }
  .fade-wait-leave.fade-wait-leave-active {
    opacity: 0;
    transition: opacity 0.4s ease-in;
  }

  .fade-wait-enter {
    opacity: 0;
  }
  .fade-wait-enter.fade-wait-enter-active {
    opacity: 1;
    /* Delay the enter animation until the leave completes */
    transition: opacity 0.4s ease-in 0.6s;
  }

  .fade-wait-height {
    transition: height 0.6s ease-in-out;
  }

  // @media print {
  //   #header,
  //   #footer,
  //   #simple-footer,
  //   #sidenav,
  //   #simple-header,
  //   #sidenav-header,
  //   .print-hide {
  //     display: none !important;
  //   }
  // }

  [class*="MuiClockPicker-arrowSwitcher"] + div {
    > div {
      background-color: transparent;
      border-style: solid;
      border-width: ${props => props.theme.globals.borderWidth.thick};
      border-color: ${props => props.theme.palette.border.main};
    }
    .Mui-disabled {
      color: ${props => props.theme.palette.text.neutralCool_700};
    }
  }

  .react-joyride__tooltip > div:nth-of-type(2) {
    justify-content: space-between !important;

    > div {
      flex: initial !important;
    }
  }


  @-webkit-keyframes mask-play {
    from {
      -webkit-mask-position: 0% 0;
              mask-position: 0% 0;
    }
    to {
      -webkit-mask-position: 100% 0;
              mask-position: 100% 0;
    }
  }

  @keyframes mask-play {
    from {
      -webkit-mask-position: 0% 0;
              mask-position: 0% 0;
    }
    to {
      -webkit-mask-position: 100% 0;
              mask-position: 100% 0;
    }
  }

  .gpt-slider .gpt-slide:nth-child(even) {
    -webkit-mask: url(/public/nature-sprite.png);
            mask: url(/public/nature-sprite.png);
    -webkit-mask-size: 2300% 100%;
            mask-size: 2300% 100%;
  }

  .gpt-slider .gpt-slide:nth-child(odd) {
    -webkit-mask: url(/public/nature-sprite-2.png);
            mask: url(/public/nature-sprite-2.png);
    -webkit-mask-size: 7100% 100%;
            mask-size: 7100% 100%;
  }

  .gpt-slider .gpt-slide:nth-child(even).hide {
    -webkit-animation: mask-play 1.4s steps(22) forwards;
            animation: mask-play 1.4s steps(22) forwards;
  }

  .gpt-slider .gpt-slide:nth-child(odd).hide {
    -webkit-animation: mask-play 1.4s steps(70) forwards;
            animation: mask-play 1.4s steps(70) forwards;
  }

  .gpt-slider .gpt-slide {
    z-index: 10;
    -webkit-mask-position: 0% 0;
            mask-position: 0% 0;
  }

  .gpt-slider .gpt-slide:nth-child(1) {
    z-index: 30;
  }

  .gpt-slider .gpt-slide:nth-child(2) {
    z-index: 20;
  }

  /* Fallback */
  .no-cssmask .gpt-slider .gpt-slide.hide {
    opacity: 0;
    -webkit-transition: opacity 1.4s ease;
            transition: opacity 1.4s ease;
    -webkit-mask: none !important;
            mask: none !important;
  }

`

export default GlobalStyle
